import { connect } from "react-redux";
import { compose } from "recompose";
import RandomRemote from "./RandomRemote";
import { selectCurrentStudent, selectPreviouslyChosenStudents, displayStudent, RandomSlice } from "src/pods/random";
import { displayOpen, displayClose, remoteClose } from "src/pods/realtime";
import { selectAttendingStudents, fetchStudents, StudentSlice } from "src/pods/students";
import { fetchTools } from "src/pods/toolkitData";
import dispatchOnMount from "src/shared/hoc/dispatchOnMount";
import withRouteParams from "src/shared/hoc/withRouteParams";

const mapStateToProps = (state: RandomSlice & StudentSlice) => ({
  students: selectAttendingStudents(state),
  selectedStudent: selectCurrentStudent(state),
  previouslyChosenStudents: selectPreviouslyChosenStudents(state),
});

const mapDispatchToProps = {
  displayOpen,
  displayClose,
  remoteClose,
  displayStudent,
};

export default compose(
  withRouteParams(["classId", "mountPoint"]),
  connect(mapStateToProps, mapDispatchToProps),
  dispatchOnMount(fetchTools, (props: { classId: string }) => ({
    classId: props.classId,
  })),
  dispatchOnMount(fetchStudents, (props: { classId: string }) => ({
    classId: props.classId,
  })),
)(RandomRemote);
